import { createApi, fetchBaseQuery, type FetchArgs, type BaseQueryFn } from "@reduxjs/toolkit/query/react";
import { storage, StorageKey } from "util/Storage";
import type SessionClient from "../../util/SessionClient";

const baseUrl = `${process.env.REACT_APP_POWUR_API_URL}/json_web`;
const rawBaseQuery = fetchBaseQuery({ baseUrl });

const setHeaders = (session: SessionClient | null) => {
  const headers = new Headers();
  headers.set("Content-Type", "application/json; charset=utf-8");
  headers.set("Accept", "*/*");
  if (session?.jwt) {
    headers.set("Authorization", `Bearer ${session.jwt}`);
  }
  return headers;
};

const customBaseQuery: BaseQueryFn<string | FetchArgs, unknown, unknown> = (args, api, extraOptions) => {
  const session = storage.getParsed<SessionClient>(StorageKey.SESSION);

  const fetchArgs: FetchArgs = typeof args === "string" ? { url: args } : args;

  const uri = new URL(fetchArgs.url, baseUrl);
  if (session?.jwt) {
    uri.searchParams.append("t_id", session.user?.id);
  }

  const finalArgs: FetchArgs = {
    ...fetchArgs,
    url: uri.pathname + uri.search,
    headers: setHeaders(session),
  };

  return rawBaseQuery(finalArgs, api, extraOptions);
};

export const api = createApi({
  reducerPath: "api",
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
});
